import React, { useEffect, useState } from 'react';
import styles from './ProgressBar.module.scss';
import { LinearProgress, linearProgressClasses, styled, Typography } from '@mui/material';
import { interpolateCSSVariable } from 'new/theme';

interface ProgressBarProps {
  current: number;
  total: number;
  valueFormatter?: (value: number) => string;
  showLabel?: boolean;
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: interpolateCSSVariable('--color-primary-700'),
  },
}));

export function ProgressBar(props: ProgressBarProps) {
  const { current, total, showLabel, valueFormatter } = props;
  const [progress, setProgress] = useState((current / total) * 100);

  useEffect(() => {
    setProgress((current / total) * 100);
  }, [current, total]);

  return (
    <div className={styles.container}>
      {showLabel ? (
        <Typography variant="body3">
          {valueFormatter(current)} of {valueFormatter(total)}
        </Typography>
      ) : null}
      <BorderLinearProgress variant="determinate" value={progress} />
    </div>
  );
}

ProgressBar.defaultProps = {
  valueFormatter: (value) => value + '',
};
